import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "__edit_registered_product bg-white p-5 border border-gray-200 rounded-2xl dark:border-gray-800" }
const _hoisted_2 = { class: "pt-5 grid grid-cols-2 gap-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_select = _resolveComponent("v-select")
  const _component_basic_button = _resolveComponent("basic_button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[11] || (_cache[11] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Registered Product Name ", -1 /* CACHED */)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.dat_editing_registered_product_name) = $event)),
        tabindex: "130",
        class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, $setup.dat_editing_registered_product_name]
      ])
    ]),
    _createElementVNode("div", null, [
      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " 3E Parts ", -1 /* CACHED */)),
      _createVNode(_component_v_select, {
        options: $setup.options_vendor_1,
        modelValue: $setup.value_vendor_1,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.value_vendor_1) = $event)),
        onSearch: $setup.fetchOptionsVendor1,
        multiple: true,
        filterable: false,
        label: "name"
      }, null, 8 /* PROPS */, ["options", "modelValue"])
    ]),
    _createElementVNode("div", null, [
      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " CED Parts ", -1 /* CACHED */)),
      _createVNode(_component_v_select, {
        options: $setup.options_vendor_2,
        modelValue: $setup.value_vendor_2,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.value_vendor_2) = $event)),
        onSearch: $setup.fetchOptionsVendor2,
        multiple: true,
        filterable: false,
        label: "name"
      }, null, 8 /* PROPS */, ["options", "modelValue"])
    ]),
    _createElementVNode("div", null, [
      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Crescent Parts ", -1 /* CACHED */)),
      _createVNode(_component_v_select, {
        options: $setup.options_vendor_3,
        modelValue: $setup.value_vendor_3,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.value_vendor_3) = $event)),
        onSearch: $setup.fetchOptionsVendor3,
        multiple: true,
        label: "name"
      }, null, 8 /* PROPS */, ["options", "modelValue"])
    ]),
    _createElementVNode("div", null, [
      _cache[15] || (_cache[15] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Republic Parts ", -1 /* CACHED */)),
      _createVNode(_component_v_select, {
        options: $setup.options_vendor_4,
        modelValue: $setup.value_vendor_4,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.value_vendor_4) = $event)),
        onSearch: $setup.fetchOptionsVendor4,
        multiple: true,
        label: "name"
      }, null, 8 /* PROPS */, ["options", "modelValue"])
    ]),
    _createElementVNode("div", null, [
      _cache[16] || (_cache[16] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Van Meter Parts ", -1 /* CACHED */)),
      _createVNode(_component_v_select, {
        options: $setup.options_vendor_5,
        modelValue: $setup.value_vendor_5,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.value_vendor_5) = $event)),
        onSearch: $setup.fetchOptionsVendor5,
        multiple: true,
        label: "name"
      }, null, 8 /* PROPS */, ["options", "modelValue"])
    ]),
    _createElementVNode("div", null, [
      _cache[17] || (_cache[17] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Altorfer Parts ", -1 /* CACHED */)),
      _createVNode(_component_v_select, {
        options: $setup.options_vendor_6,
        modelValue: $setup.value_vendor_6,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.value_vendor_6) = $event)),
        onSearch: $setup.fetchOptionsVendor6,
        multiple: true,
        label: "name"
      }, null, 8 /* PROPS */, ["options", "modelValue"])
    ]),
    _createElementVNode("div", null, [
      _cache[18] || (_cache[18] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Anixter Parts ", -1 /* CACHED */)),
      _createVNode(_component_v_select, {
        options: $setup.options_vendor_7,
        modelValue: $setup.value_vendor_7,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.value_vendor_7) = $event)),
        onSearch: $setup.fetchOptionsVendor7,
        multiple: true,
        label: "name"
      }, null, 8 /* PROPS */, ["options", "modelValue"])
    ]),
    _createElementVNode("div", null, [
      _cache[19] || (_cache[19] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Echo Parts ", -1 /* CACHED */)),
      _createVNode(_component_v_select, {
        options: $setup.options_vendor_10,
        modelValue: $setup.value_vendor_10,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.value_vendor_10) = $event)),
        onSearch: $setup.fetchOptionsVendor10,
        multiple: true,
        label: "name"
      }, null, 8 /* PROPS */, ["options", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_basic_button, {
        onClick: _cache[9] || (_cache[9] = $event => ($setup.save())),
        size: $setup.Size.large
      }, {
        default: _withCtx(() => _cache[20] || (_cache[20] = [
          _createElementVNode("i", { class: "fa-solid fa-floppy-disk" }, null, -1 /* CACHED */),
          _createTextVNode(" Save ")
        ])),
        _: 1 /* STABLE */,
        __: [20]
      }, 8 /* PROPS */, ["size"]),
      _createVNode(_component_basic_button, {
        onClick: _cache[10] || (_cache[10] = $event => ($setup.cancel())),
        size: $setup.Size.small
      }, {
        default: _withCtx(() => _cache[21] || (_cache[21] = [
          _createElementVNode("i", { class: "fa-solid fa-circle-xmark" }, null, -1 /* CACHED */),
          _createTextVNode(" Cancel ")
        ])),
        _: 1 /* STABLE */,
        __: [21]
      }, 8 /* PROPS */, ["size"])
    ])
  ]))
}